module.exports = __webpack_public_path__ + "static/media/2.d96567b9.jpg";